/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';

import { cssMap, jsx } from '@atlaskit/css';
// Uses @compiled/react because fractional opacity (0.5) is not an allowed value in the strict @atlaskit/css types.
import { cssMap as compiledCssMap } from '@compiled/react';
import { token } from '@atlaskit/tokens';

const badgeWrapperStyles = compiledCssMap({
	badge: {
		display: 'inline-flex',
		marginLeft: token('space.050'),
		opacity: 0.5,
	},
});

const styles = cssMap({
	container: {
		display: 'inline-flex',
		alignItems: 'center',
	},
	labelValue: {
		marginLeft: token('space.050'),
		display: 'inline-flex',
		alignItems: 'center',
	},
});

export const BadgeWrapper = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={badgeWrapperStyles.badge} {...props}>
		{children}
	</div>
);

export const Container = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.container} {...props}>
		{children}
	</div>
);

export const LabelValueWrapper = ({
	children,
	...props
}: React.ComponentPropsWithoutRef<'div'>): React.JSX.Element => (
	<div css={styles.labelValue} {...props}>
		{children}
	</div>
);
